import React from 'react';
import { Colors } from '../../constants';

const PrevIcon = ({ handleOnClick, color = `#${Colors.blackText}` }) => {
  return(
    <button className="icon" onClick={() => handleOnClick()} >
      <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.73745 1.26255L1 6L5.73745 10.7374" 
          stroke={color} 
          strokeWidth="1.67494" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
      </svg>
    </button>
  )
};

export default PrevIcon;